import { useSelector } from 'react-redux';
import removeSvg from 'assets/icons/remove.svg';
import { RootState } from 'store';
import { deleteCreative } from 'modules/api/content';
import { useToggle } from 'customHooks/useToggle';
import { cancelFunctions } from 'utils/cancelFunctions';
import Modal from 'lib/Modal';
import Button, { Size, Color } from 'lib/Button';
import { DeleteRestoreCreativeProps } from './ButtonRenderer.types';

export const DeleteCreative: React.FC<DeleteRestoreCreativeProps> = ({ data, onComplete }) => {
  const deleteDialog = useToggle();
  const environmentId = useSelector((state: RootState) => state.environment.environmentId);

  const onDelete = async (): Promise<void> => {
    try {
      const marketId = data.market.find(({ environment }) => environment === environmentId)?.id;
      await deleteCreative(cancelFunctions, marketId);

      onComplete();
    } finally {
      deleteDialog.close();
    }
  };

  return (
    <>
      <Button
        onClick={deleteDialog.open}
        size={Size.LARGE}
        color={Color.PRIMARY}
        ariaLabel="Delete Creative"
        dataTestId={`delete-creative-button-${data.id}`}
        svg={removeSvg}
      />

      <Modal
        dataTestId="delete-creative-modal"
        isOpen={deleteDialog.isOpen}
        icon={removeSvg}
        title="Delete Creative?"
        actionButtons={
          <>
            <Button color={Color.PRIMARY} size={Size.LARGE} onClick={deleteDialog.close} label="Cancel" />
            <Button color={Color.DANGER} size={Size.LARGE} onClick={onDelete} label="Delete" />
          </>
        }
      >
        <p className="ml-8 body-base text-neutral-950-opacity-60">Are you sure you want to delete this creative?</p>
      </Modal>
    </>
  );
};
